export default __webpack_public_path__ + "static/media/ic_check.ea8ef857.svg";